import React from 'react'
import { pdf } from '@react-pdf/renderer'
import { getData } from '../../../api/indexedDBHandler'
import PairComandSvodGroupTournamentProtocolPDF from './PairComandSvodGroupTournamentProtocolPDF'
import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'

const getname = (teamData, competition_type = 'Рейтинговое соревнование') => {
  //  console.log('teamData', teamData)
  if (competition_type == 'Рейтинговое соревнование') {
    return teamData?.team_name_ru
  }
  return teamData?.preferred_name == 'en'
    ? teamData?.team_name_en
      ? teamData?.team_name_en
      : teamData?.team_name_ru
    : teamData?.team_name_ru
}
// Выносим логику генерации протокола в отдельную функцию
const generateProtocolData = async (id) => {
  console.log('generateProtocolData', id)
  const resultsU = await getData('teams', 'id', id)
  if (resultsU.length === 0) throw new Error('No team data found')

  const { value: teamValue } = resultsU[0]
  const teamsInfo = Object.values(teamValue).filter(
    (teamEntry) =>
      teamEntry !== null &&
      typeof teamEntry === 'object' &&
      teamEntry.team?.status === 'Заявка одобрена' &&
      teamEntry.team?.status_location === 1
  )
  const resultsT = await getData('tournaments', 'id', id)
  if (resultsT.length === 0) throw new Error('No tournament data found')

  const { value: tournamentValue } = resultsT[0]
  const isFinish = tournamentValue.status_cup === 'Турнир завершен'
  const allLogos = Object.values(tournamentValue.sponsor || {})
  const administrator = Object.values(tournamentValue.administrator || [])

  const resultsS = await getData('stage', 'id', id)
  if (resultsS.length === 0) throw new Error('No stage data found')

  const { value: stageValue } = resultsS[0]
  const data = Object.values(stageValue).filter(
    (teamEntry) => teamEntry !== null && typeof teamEntry === 'object'
  )

  const teams = {}
  teamsInfo.forEach((team) => {
    const sp1sports_category = team.athlete[0]?.sports_category
      ? ' (' + team.athlete[0]?.sports_category + ')'
      : ''
    const sp1 = team.athlete[0]?.fio ? team.athlete[0]?.fio : ''

    const sp2sports_category = team.athlete[1]?.sports_category
      ? ' (' + team.athlete[1]?.sports_category + ')'
      : ''
    const sp2 = team.athlete[1]?.fio ? ', ' + team.athlete[1]?.fio : ''

    const sp3sports_category = team.athlete[2]?.sports_category
      ? ' (' + team.athlete[2]?.sports_category + ')'
      : ''
    const sp3 = team.athlete[2]?.fio ? ', ' + team.athlete[2]?.fio : ''

    const name = getname(team.team, tournamentValue?.competition_type)
      ? getname(team.team, tournamentValue?.competition_type)
      : ''
    //   console.log('name', name)
    teams[team.team.id] = {
      id: team.team.id,
      team: name,
      zone: team.team.zona,
      sp:
        sp1 +
        sp1sports_category +
        sp2 +
        sp2sports_category +
        sp3 +
        sp3sports_category,
      sector: team.team.sector,
      totalWeight: 0,
      fishCount: 0,
      biggestFish: 0,
      averageWeight: 0,
      weightDifference: 0,
    }
  })

  // Подсчитываем уловы
  data[0]?.forEach((entry) => {
    // console.log('entry', entry)
    if (entry.fishList && entry.fishList[0].weight === 0) return

    if (teams[entry.teamId] && entry.fishList && entry.fishList.length > 0) {
      const weight = entry.fishList.reduce((sum, fish) => sum + fish.weight, 0)
      const biggestFish = Math.max(...entry.fishList.map((fish) => fish.weight))
      // teams[entry.teamId].sp = sp1
      if (entry.teamName && entry.teamName != '')
        teams[entry.teamId].team = entry.teamName
      teams[entry.teamId].totalWeight += weight
      teams[entry.teamId].fishCount += entry.fishList.length
      teams[entry.teamId].biggestFish = Math.max(
        teams[entry.teamId].biggestFish,
        biggestFish
      )
    } else {
      if (entry.teamName && entry.teamName != '')
        teams[entry.teamId].team = entry.teamName ?? entry.teamName
      //  teams[entry.teamId].sp = sp1
    }
  })

  // Вычисляем средний вес рыбы у каждой команды
  Object.values(teams).forEach((team) => {
    if (team.fishCount > 0) {
      team.averageWeight = Math.round(team.totalWeight / team.fishCount)
    }
  })
  //  console.log('data.forEach:', data)
  //  console.log('teams.forEach:', teams)
  // Группировка команд по зонам
  const zones = {}
  Object.values(teams).forEach((team) => {
    if (!zones[team.zone]) zones[team.zone] = []
    zones[team.zone].push(team)
  })

  Object.keys(zones).forEach((zone) => {
    // Разделяем команды на тех, кто поймал рыбу и нет
    const withFish = zones[zone].filter((team) => team.totalWeight > 0)
    const withoutFish = zones[zone].filter((team) => team.totalWeight === 0)

    // Сортируем только команды с рыбой
    withFish.sort(
      (a, b) =>
        b.totalWeight - a.totalWeight ||
        b.fishCount - a.fishCount ||
        b.biggestFish - a.biggestFish
    )

    // Находим вес лидера зоны (первой команды с рыбой)
    const leaderWeight = withFish.length > 0 ? withFish[0].totalWeight : 0

    // Рассчитываем отставание для каждой команды с рыбой
    withFish.forEach((team, index) => {
      team.weightBehindLeader = leaderWeight - team.totalWeight
    })

    // Для команд без рыбы устанавливаем отставание как вес лидера (максимальное отставание)
    withoutFish.forEach((team) => {
      team.weightBehindLeader = leaderWeight
    })

    // Объединяем (сначала команды с рыбой, потом без)
    const sortedZone = [...withFish, ...withoutFish]

    // Назначаем места
    sortedZone.forEach((team, index) => {
      // Все команды без рыбы получают максимальный (последний) номер места
      team.zoneRank = team.totalWeight === 0 ? sortedZone.length : index + 1
    })

    // Обновляем массив зоны
    zones[zone] = sortedZone
  })
  const biggestFish = Object.values(teams).reduce(
    (max, team) =>
      team.biggestFish > max.weight
        ? { weight: team.biggestFish, team: team.name }
        : max,
    { weight: 0, team: '' }
  )
  const zoneKeys = Object.keys(zones)
  // Общие данные по соревнованию
  const totalFishCountA = Object.values(zones['А']).reduce(
    (sum, team) => sum + team.fishCount,
    0
  )
  const totalFishCountB = Object.values(zones['Б']).reduce(
    (sum, team) => sum + team.fishCount,
    0
  )
  const totalFishCountC = zoneKeys.includes('В')
    ? Object.values(zones['В']).reduce((sum, team) => sum + team.fishCount, 0)
    : 0

  const totalWeightA = Object.values(zones['А']).reduce(
    (sum, team) => sum + team.totalWeight,
    0
  )
  const totalWeightB = Object.values(zones['Б']).reduce(
    (sum, team) => sum + team.totalWeight,
    0
  )
  const totalWeightC = zoneKeys.includes('В')
    ? Object.values(zones['В']).reduce((sum, team) => sum + team.totalWeight, 0)
    : 0

  const averageFishWeightA =
    totalFishCountA > 0 ? totalWeightA / totalFishCountA : 0
  const averageFishWeightB =
    totalFishCountB > 0 ? totalWeightB / totalFishCountB : 0

  const averageFishWeightC =
    zoneKeys.includes('В') && totalFishCountC > 0
      ? totalWeightC / totalFishCountC
      : 0

  const arrFC = { А: totalFishCountA, Б: totalFishCountB }
  const arrFW = { А: totalWeightA, Б: totalWeightB }
  const arrAFW = {
    А: Math.round(averageFishWeightA),
    Б: Math.round(averageFishWeightB),
  }

  if (zoneKeys.includes('В')) {
    arrFC.В = totalFishCountC
    arrFW.В = totalWeightC
    arrAFW.В = Math.round(averageFishWeightC)
  }
  return {
    allLogos,
    mainLogo: getLogoUrl(tournamentValue?.logocup),
    data: zones,
    administrator,
    tournament: tournamentValue,
    date: dateNowProtocol(new Date()),
    totalFishCount: arrFC,
    totalWeight: arrFW,
    averageFishWeight: arrAFW,

    biggestFish: biggestFish,
    isFinish: isFinish,
    // isFinish,
    // processedData: [], // Замените на ваши обработанные данные
    // totalFishCount: 0, // Замените на реальные значения
    // totalWeight: 0,
    // averageFishWeight: 0,
    // biggestFish: { weight: 0, pair: '' },
  }
}

const DocProtocolPairComandSvodGroup = ({ isProtocolSvodCallback }) => {}
export default {
  generate: async function (id) {
    try {
      const protocolData = await generateProtocolData(id)
      console.log('protocolData', protocolData)
      const pdfDoc = (
        <PairComandSvodGroupTournamentProtocolPDF
          allLogo={protocolData.allLogos}
          mainLogo={getLogoUrl(protocolData.tournament?.logocup)}
          data={protocolData.data}
          administrator={protocolData.administrator}
          tournament={protocolData.tournament}
          date={dateNowProtocol(new Date())}
          totalFishCount={protocolData.totalFishCount}
          totalWeight={protocolData.totalWeight}
          averageFishWeight={protocolData.averageFishWeight}
          biggestFish={protocolData.biggestFish}
          isfinish={protocolData.isFinish}
        />
      )

      const blob = await pdf(pdfDoc).toBlob()
      const url = URL.createObjectURL(blob)

      const servaurl = await uploadPdfToServer(blob, id)
      return {
        blob,
        previewUrl: servaurl,
        data: protocolData,
      }
    } catch (error) {
      console.error('Ошибка при генерации протокола:', error)
      throw error
    }
  },
}
const uploadPdfToServer = async (blob, id) => {
  try {
    const formData = new FormData()
    formData.append(
      'pdf',
      blob,
      `сводный_протокол_${dateNowProtocol(new Date())}.pdf`
    )
    formData.append('id', id)
    formData.append('isPost', 3)

    formData.append('type', 'ProtocolGroup')
    const response = await fetch(
      'https://www.admin-protocarp.ru/php/uploads/upload.php',
      {
        method: 'POST',
        body: formData,
      }
    )

    if (response.ok) {
      const result = await response.json()
      // Обновляем URL на серверный, если нужно
      return { fileUrl: result.fileUrl }
    } else {
      console.error('Ошибка загрузки файла на сервер')
      return { fileUrl: null }
    }
  } catch (error) {
    console.error('Ошибка при загрузке на сервер:', error)
    return { fileUrl: null }
  }
}
